var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.35 19.5875L17.475 17.275C17.1181 17.0362 16.8216 16.7176 16.609 16.3445C16.3963 15.9713 16.2735 15.5538 16.25 15.125V10",
    stroke: "#0001a5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.74052 13.4493C6.06545 12.2692 6.56161 11.1432 7.21317 10.1071C8.50159 8.06074 10.4369 6.50363 12.7116 5.68316C14.9863 4.86269 17.47 4.82592 19.768 5.57867C22.0661 6.33143 24.0466 7.83055 25.3951 9.83785C26.7435 11.8451 27.3825 14.2455 27.2105 16.6575C27.0384 19.0696 26.0653 21.355 24.4457 23.1506C22.826 24.9463 20.6528 26.1491 18.2712 26.5682C15.8896 26.9872 13.4363 26.5984 11.301 25.4634C9.16574 24.3284 7.47098 22.5125 6.486 20.304",
    stroke: "#2762FB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.16728 14.9204L3.58447 9.65088",
    stroke: "#0001a5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.16718 14.9204L10.0154 12.9979",
    stroke: "#0001a5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.ebaf9f5d.svg";
export { ForwardRef as ReactComponent };